import { useState, useEffect } from "react";
import { Font } from "@react-pdf/renderer";
import RobotoFontSrc from "../../dataFiles/fonts/Roboto-Regular.ttf";
import ThaiFontSrc from "../../dataFiles/fonts/NotoSansThai-Regular.ttf";
import TCFontSrc from "../../dataFiles/fonts/NotoSansTC-Regular.ttf";
import HebrewFontSrc from "../../dataFiles/fonts/NotoSansHebrew-Regular.ttf";

// Font Array
const FontArray = [
  { family: "Roboto", src: RobotoFontSrc, langArr: ["English"] },
  { family: "Noto Sans Thai", src: ThaiFontSrc, langArr: ["th"] },
  {
    family: "Noto Sans TC",
    src: TCFontSrc,
    langArr: ["Chinese (Traditional)", "Chinese (Simplifed)"],
  },
  { family: "Noto Sans Hebrew", src: HebrewFontSrc, langArr: ["he"] },
];

// Function to Get Font Based on Language
const getFontByLanguage = (language) => {
  const font = FontArray.find((f) => f.langArr.includes(language));
  return font || { family: "Roboto", src: RobotoFontSrc }; // Default to Roboto
};

// Custom Hook
const useDynamicFont = (language) => {
  const [fontFamily, setFontFamily] = useState("Roboto");

  useEffect(() => {
    const registerFont = async () => {
      const { family, src } = getFontByLanguage(language);
      Font.register({ family, src, format: "truetype" });
      setFontFamily(family);
    };

    registerFont();
  }, [language]);

  return fontFamily;
};

export default useDynamicFont;
